module.exports = __webpack_public_path__ + "img/clothing12.c0e92e45.jpg";